import React from 'react';
import { ContainerItem } from '../index';
import List from './List';

const FileListContainer = ({ files }: any) => (
  <ContainerItem xs={12} alignItems="center">
    <List files={files} />
  </ContainerItem>
);

export default FileListContainer;
